export class PublicHoliday {
    id: number;
    active: boolean;
    description: string;
    date : Date;
  }